import styled from "styled-components";

import { Spacing, Text, media } from "@otta/design";
import {
  pxToRem,
  borderRadius,
  modularScale,
  palette,
} from "@otta/design-tokens";
import { Link } from "@otta/search/components/Link";
import { Company } from "@otta/search/schema";

const Container = styled.div`
  padding: ${modularScale(2)} 0;

  ${media({ from: "tablet" })`
    padding: 0 ${modularScale(2)};
  `}
`;

const CountsContainer = styled.div``;

const CountTag = styled.div`
  margin-bottom: ${modularScale(-3)};
  display: flex;
`;

const CountTagLeft = styled.div<{ roundAllBorders: boolean }>`
  padding: ${pxToRem(6)} ${pxToRem(14)};
  background-color: ${palette.brand.yellow};
  color: ${palette.brand.black};
  border-radius: ${({ roundAllBorders }) =>
    roundAllBorders ? `${pxToRem(10)}` : `${pxToRem(10)} 0 0 ${pxToRem(10)}`};
`;

const CountTagRight = styled.div`
  padding: ${pxToRem(6)} ${pxToRem(12)};
  background-color: ${palette.brand.white};
  color: ${palette.brand.black};
  border-radius: 0 ${pxToRem(10)} ${pxToRem(10)} 0;
  border-color: ${palette.brand.yellow};
  border: ${pxToRem(1)} solid ${palette.brand.yellow};
`;

const Info = styled.div`
  background-color: ${palette.extended.green.shade300};
  color: ${palette.brand.black};
  padding: ${pxToRem(5)} ${pxToRem(10)};
  border-radius: ${pxToRem(borderRadius)};
  display: flex;
  width: fit-content;
  align-items: center;
`;

interface ISurveySummaryContainerProps {
  company: Company.Company;
}

export function SurveySummaryContainer({
  company: { name, employeeSurveys, responseCountByCategory },
}: ISurveySummaryContainerProps): React.ReactElement {
  return (
    <Container>
      <Spacing size={2}>
        <Spacing size={-1}>
          <Text bold size={1}>
            Endorsements from {employeeSurveys.length} employee
            {employeeSurveys.length > 1 ? "s" : null}
          </Text>
          <Info>
            <Text size={-1}>
              All endorsements from{" "}
              <Text as="span" size={-1} bold>
                verified employees
              </Text>
            </Text>
          </Info>
        </Spacing>
        <Spacing size={-1}>
          <Text>Highlights</Text>
          <CountsContainer>
            {responseCountByCategory.map(({ id, categoryName, count }) => (
              <CountTag key={id} data-testid="response-count-tag">
                <CountTagLeft roundAllBorders={count === 1}>
                  <Text size={-1}>{categoryName}</Text>
                </CountTagLeft>
                {count > 1 && (
                  <CountTagRight>
                    <Text size={-1}>{count}</Text>
                  </CountTagRight>
                )}
              </CountTag>
            ))}
          </CountsContainer>
        </Spacing>
        <Text>
          Work at {name}?{" "}
          <Link to="../write-an-endorsement">Leave an endorsement.</Link>
        </Text>
      </Spacing>
    </Container>
  );
}
